import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as Classes from './styles.module.scss';
import {
  linkTo, renderItemPrice, renderValue, renderImage
} from './art_item';
import RemoveCartItem from './remove_cart_item';

const PATH = '/frames';

const FrameItem = ({
  name,
  imageUrl,
  price,
  salesPrice,
  uid,

  frameName,
  frameLabel,
  finalFramedSize,
  displayWidth,
  displayDepth,
  mat,

  id,
  editable,
  removeCartItem,
  isAvailable,

  realLinks,
  locale
}) => (
  <div className={ classnames(Classes.item, Classes.classic) }>
    { renderImage(realLinks, `${ PATH }/${ uid }`, imageUrl, name) }
    <div className={ Classes.info }>
      <h4>
        { linkTo(realLinks, `${ PATH }/${ uid }`, name) }
      </h4>
      { frameName ? renderValue(`${ frameLabel }:`, `${ frameName } ${ mat || '' }`) : null }
      { displayWidth ? renderValue('Frame Width:', displayWidth) : null }
      { displayDepth ? renderValue('Frame Depth:', displayDepth) : null }
      { finalFramedSize ? renderValue('Final Framed Size:', finalFramedSize) : null }
      {
        isAvailable ? null : (
          <div className={ Classes.error }>
            This item is no longer available
          </div>
        )
      }
    </div>
    <div className={ Classes.rightColumn }>
      { editable ? <RemoveCartItem removeCartItem={ removeCartItem } id={ id } /> : null }
      { renderItemPrice(price, salesPrice, locale) }
    </div>
  </div>
);

FrameItem.propTypes = {
  name: PropTypes.string.isRequired,
  imageUrl: PropTypes.string.isRequired,
  price: PropTypes.string.isRequired,
  salesPrice: PropTypes.string,
  frameName: PropTypes.string,
  frameLabel: PropTypes.string,
  finalFramedSize: PropTypes.string,
  mat: PropTypes.string,
  uid: PropTypes.string,
  id: PropTypes.number.isRequired,
  editable: PropTypes.bool,
  removeCartItem: PropTypes.func,
  isAvailable: PropTypes.bool.isRequired,
  realLinks: PropTypes.bool,
  locale: PropTypes.string.isRequired,
  displayWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  displayDepth: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default FrameItem;
